import { PayloadTopicRongHo, StoreUserBetRH } from "models/rong-ho-model";
import { ChipItem, ParamBetRongHo, PayloadBodyUserQueueTXCB } from "models/txcb-model";
import { forwardRef, useEffect, useMemo, useRef, useState } from "react";
import ReactDOMServer from 'react-dom/server';
import rhFunction from "./rongho-function";
import { reloadBalance } from "utils/function";
import './board-rongho.scss';
import React from "react";
import ChipsRongho from "./chips-rongho";
import PlaceBetRongHo from "./place-bet-rongho";
import bgAudio from 'assets/images/audio/multichip.mp3';

interface Props {
    balance: string;
    bodyTopic: PayloadTopicRongHo;
    userQueue: PayloadBodyUserQueueTXCB;
    onBet: (action: string, payload: ParamBetRongHo) => void;
    onUpdatePhien: (value: { id: string; result: string[] }[]) => void;
    lspData: { id: string; result: string[] }[];
    onClose: () => void;
    onChangeMsg: (inputData: string) => void;
}
function BoardRongHo(props: Props, ref: any) {
    const { balance, bodyTopic, userQueue, onBet, onUpdatePhien, lspData, onClose, onChangeMsg } = props;

    const paramsBet: ParamBetRongHo = useMemo(
        () => ({ rongHoId: '', userId: 0, loginname: '', betamount: 0, typed: 0, userType: 0, betfrom: 0, dragon: 0, tiger: 0, draw: 0 }),
        []
    );
    const timerRef = useRef<HTMLDivElement>(null);
    const timerFinishRef = useRef<HTMLDivElement>(null);
    const placeActiveRef = useRef<any>(null);
    let chipStoreBet = useRef<HTMLDivElement[]>([]);

    const chipsListRef = useRef<any[]>([]);

    const isNextPhien = useRef(false);

    const [timerCount, setTimerCount] = useState('');
    const [issue, setIssue] = useState('');
    const [showHotTimer, setShowHotTimer] = useState(false);
    const [hideTimer, setHideTimer] = useState(false);

    const [moneyCountTai, setMoneyCountTai] = useState(0); // rồng
    const [moneyCountXiu, setMoneyCountXiu] = useState(0); //hổ
    const [moneyCountHoa, setMoneyCountHoa] = useState(0); // hoà

    const [countUser, setCountUser] = useState<StoreUserBetRH>({ tai: 0, xiu: 0, hoa: 0 });
    const [result, setResult] = useState<string[] | null>(null); // phiên cược
    const [timerFinish, setTimerFinish] = useState('');
    const [chipValue, setChipValue] = useState(1000);

    const [stateBtnBet, setStateBtnBet] = useState<'RONG' | 'HO' | 'HOA' | ''>('');
    const [storeMyBet, setStoreMyBet] = useState<StoreUserBetRH>({ tai: 0, xiu: 0, hoa: 0 }); // store cược ván trước (chức năng đặt lại)
    const [countConfirmBet, setCountConfirmBet] = useState<StoreUserBetRH>({ tai: 0, xiu: 0, hoa: 0 }); // tiền cược đã confirm

    const [currentMyBet, setcurrentMyBet] = useState<StoreUserBetRH>({ tai: 0, xiu: 0, hoa: 0 }); //tiền cược chưa confirm

    const [tkBoardList, setTkBoardList] = useState<{ id: string; result: string[] }[]>([]);
    const [totalCurrentBet, setTotalCurrentBet] = useState(0);
    const [activePlaceWin, setActivePlaceWin] = useState<'RONG' | 'HO' | 'HOA' | ''>('');

    const [showCard, setShowCard] = useState(false);

    const moneyWin = useRef<number>(0);
    const isShowingWin = useRef(false);

    const backgroundAudio = useMemo(() => new Audio(bgAudio), []);

    const updateMoneyWin = (value: number) => {
        moneyWin.current = value;
    };

    useEffect(() => {
        //bắt đầu phiên mới
        if (bodyTopic.cmd === 1) {
            // console.log(bodyTopic);
            paramsBet.rongHoId = bodyTopic.id;

            setIssue(bodyTopic.id);
            setTimerFinish('');
            //đếm tổng cược tài (rồng)
            if (bodyTopic.ar !== 0) {
                setMoneyCountTai(bodyTopic.ar);
            }

            // đếm tổng cược xỉu (hổ)
            if (bodyTopic.ah !== 0) {
                setMoneyCountXiu(bodyTopic.ah);
            }

            // đếm tổng cược hoà
            if (bodyTopic.ae !== 0) {
                setMoneyCountHoa(bodyTopic.ae);
            }

            //thời gian cược
            setTimerCount(`0${bodyTopic.cd}`.slice(-2));
            if (bodyTopic.cd <= 10) {
                setShowCard(true);
                if (bodyTopic.cd === 10) {
                    backgroundAudio.play();
                }
            }

            //count user cược
            setCountUser({ tai: bodyTopic.ur, xiu: bodyTopic.uh, hoa: bodyTopic.ue });
        }

        //kết quả phiên và hiệu ứng mở thưởng
        if (bodyTopic.cmd === 5 && bodyTopic.cd === -1) {
            let hisPhien = lspData;
            const lspLast = { id: bodyTopic['id'], result: bodyTopic['rs'] || [] };
            hisPhien = [...hisPhien, lspLast];
            const hisPhienLast = JSON.parse(JSON.stringify(hisPhien)).filter((_: any, index: number) => index < 14);

            onUpdatePhien(hisPhien);
            setTkBoardList(hisPhienLast);
            setHideTimer(true);
            setResult(bodyTopic.rs);
        }

        //count finish phiên
        if (bodyTopic.cmd === 2 && bodyTopic.cd <= 14) {
            setTimerFinish(`0${bodyTopic.cd}`.slice(-2));
            if (timerFinishRef.current) {
                timerFinishRef.current.style.transform = 'scale(1.25)';
                setTimeout(() => {
                    if (timerFinishRef.current) {
                        timerFinishRef.current.style.transform = 'scale(1)';
                    }
                }, 160);
            }
            if (bodyTopic.cd === 0) {
                handleGetMsg('Bắt đầu phiên mới');
                setHideTimer(false);
                setShowCard(false);
                setResult(null);
                setCountConfirmBet({ tai: 0, xiu: 0, hoa: 0 });
                setMoneyCountTai(0);
                setMoneyCountXiu(0);
                setMoneyCountHoa(0);

                updateMoneyWin(0);
                isShowingWin.current = false;
            }
        }
        isNextPhien.current = false;
        if (bodyTopic.cmd === 2 && bodyTopic.cd <= 17) {
            isNextPhien.current = true;
        }
    }, [bodyTopic]);

    const handleGetMsg = (msg: any) => {
        onChangeMsg(msg);
    };
    

    useEffect(() => {
        if (userQueue.cmd === 3) {
            //bắt đầu cược
            if (userQueue.status === 0) {
                setCountConfirmBet((value) => {
                    return {
                        tai: (value.tai += paramsBet.dragon),
                        xiu: (value.xiu += paramsBet.tiger),
                        hoa: (value.hoa += paramsBet.draw),
                    };
                });
                resetBet();
                reloadBalance();
                paramsBet.betamount = 0;
                handleGetMsg('Đặt cược thành công');
                reloadBalance();
            } else if (userQueue.status === 8) {
                handleGetMsg('Không thể đặt đối nghịch!');
                resetBet();
            } else if (userQueue.status === 1 && hideTimer) {
                handleGetMsg('Phiên mới chưa bắt đầu!');
            } else if (userQueue.status === 1 && !hideTimer) {
                handleGetMsg('Hết thời gian đặt cược!');
            } else if (userQueue.status === 99) {
                handleGetMsg('Lỗi hệ thống!');
            } else if (userQueue.status === 13) {
                handleGetMsg('Số tiền đặt cược không chính xác!');
            } else if (userQueue.status === 14) {
                handleGetMsg('Nhằm đảm bảo sự an toàn của tài khoản, mời quý khách đăng nhập lại vào tài khoản sau đó đổi mật khẩu trước khi đặt cược!');
            } else if (userQueue.status === 15) {
                handleGetMsg('Tài khoản đã bị khóa,không thể tiến hành đặt cược!');
            } else if (userQueue.status === 16) {
                handleGetMsg('Số dư tài khoản không đủ!');
            } else if (userQueue.status === 17) {
                handleGetMsg('Nhắc nhở: Tổng đại lý không thể đặt cược!');
            } else if (userQueue.status === 10) {
                handleGetMsg('Cược ít nhất 1K, nhiều nhất 100tr!');
            }
        }

        // START return money win if has betting
        if (userQueue.cmd === 4 && userQueue.amount > 0 && !isShowingWin.current) {
            isShowingWin.current = true;
    
            setTimeout(() => {
                updateMoneyWin(userQueue.amount);
                setTimeout(() => {
                    updateMoneyWin(0);
                }, 3000)
            }, 1500);
        }

        //bắt đầu lịch sử phiên
        if (userQueue.cmd === 6) {
            const listHisPhien = userQueue.data
                .filter((item) => item.result !== null)
                .map((item) => ({ id: item.id, result: item.result.split(',') }))
                .slice(0, 75)
                .reverse();
            onUpdatePhien(listHisPhien);
            const listDotHisPhien: { id: string; result: string[] }[] = JSON.parse(JSON.stringify(listHisPhien)).filter(
                (_: any, index: number) => index < 14
            );
            setTkBoardList(listDotHisPhien);
        }

        // lấy tổng cược hiện tại
        if (userQueue.cmd === 13) {
            const [rong, ho, hoa] = userQueue.rs.split(',').map((el) => el.split(':')[0]);
            if (Number(rong) !== countConfirmBet.tai || Number(ho) !== countConfirmBet.xiu || Number(hoa) !== countConfirmBet.hoa) {
                handleGetMsg('Đặt cược thành công');
                if (ref.current) {
                    chipStoreBet.current = Array.from(ref.current.querySelectorAll('.chipEmbed'));
                }
                resetBet();
            }

            setCountConfirmBet({ tai: Number(rong), xiu: Number(ho), hoa: Number(hoa) });

            setStoreMyBet({
                tai: Number(rong),
                xiu: Number(ho),
                hoa: Number(hoa),
            });
        }
    }, [userQueue]);

    useEffect(() => {
        if (result) {
            handleOpenWin(result);
        }
    }, [result]);

    useEffect(() => {
        setShowHotTimer(Number(timerCount) < 10);
        if (Number(timerCount) < 10 && timerRef.current) {
            timerRef.current.style.transform = 'scale(1.25)';
            setTimeout(() => {
                if (timerRef.current) {
                    timerRef.current.style.transform = 'scale(1)';
                }
            }, 160);
        }
    }, [timerCount]);

    const handleOpenWin = (result: string[]) => {
        if (result) {
            const long = Number(result[0].split('-')?.[0]);
            const ho = Number(result[1].split('-')?.[0]);
            if (long > ho) {
                setActivePlaceWin('RONG');
            } else if (long < ho) {
                setActivePlaceWin('HO');
            } else {
                setActivePlaceWin('HOA');
            }
        } else {
            setActivePlaceWin('');
        }
    };

    const selectBet = (place: 'RONG' | 'HO' | 'HOA', placeEl: Element) => {
        setStateBtnBet(place);
        placeActiveRef.current = placeEl;
    };

    const renderHTMLChip = (item: ChipItem, currentBet: number) => {
        let labelChip = '';
        if (currentBet > 1000 && currentBet < 1000000) {
            labelChip = `${currentBet / 1000}K`;
        } else if (currentBet >= 1000000) {
            labelChip = `${currentBet / 1000000}M`;
        }
        return (
            <div style={{ cursor: 'unset' }} className="chip-item">
                <img src={require(`assets/images/chips/${item.icon}`)} alt="" />
                <p>{labelChip}</p>
            </div>
        );
    };

    const selectChip = (chipSelect: ChipItem) => {
        setChipValue(chipSelect.val);
        setTotalCurrentBet((value) => (value += chipSelect.val));

        if (stateBtnBet !== '') {
            setcurrentMyBet((obj) => {
                let currentBet = 0;
                if (stateBtnBet === 'RONG') {
                    obj = { ...obj, tai: obj.tai + chipSelect.val };
                    currentBet = obj.tai;
                } else if (stateBtnBet === 'HO') {
                    obj = { ...obj, xiu: obj.xiu + chipSelect.val };
                    currentBet = obj.xiu;
                } else if (stateBtnBet === 'HOA') {
                    obj = { ...obj, hoa: obj.hoa + chipSelect.val };
                    currentBet = obj.hoa;
                }
                //chip effect bet
                const chipCloneJXS = renderHTMLChip(chipSelect, currentBet);
                const htmlString = ReactDOMServer.renderToStaticMarkup(chipCloneJXS);
                if (placeActiveRef.current) {
                    rhFunction.effectChipBet(htmlString, chipsListRef.current, placeActiveRef.current, stateBtnBet, chipSelect.val, 0.7);
                }
                return obj;
            });
        } else {
            handleGetMsg('Vui lòng chọn cửa cược');
        }
    };

    const confirmBet = () => {
        if (isNextPhien.current) {
            handleGetMsg('Phiên mới chưa bắt đầu');
            return;
        }
        if (stateBtnBet === '') {
            handleGetMsg('Vui lòng chọn cửa cược');
            return;
        }
        if (currentMyBet.tai === 0 && currentMyBet.xiu === 0 && currentMyBet.hoa === 0) {
            handleGetMsg('Vui lòng đặt tiền cược');
            return;
        }

        if (currentMyBet.tai > 0) {
            paramsBet.typed = 1;
            paramsBet.betamount = currentMyBet.tai;
            paramsBet.dragon = currentMyBet.tai;
        } else if (currentMyBet.xiu > 0) {
            paramsBet.typed = 2;
            paramsBet.betamount = currentMyBet.xiu;
            paramsBet.tiger = currentMyBet.xiu;
        } else if (currentMyBet.hoa > 0) {
            paramsBet.typed = 3;
            paramsBet.betamount = currentMyBet.hoa;
            paramsBet.draw = currentMyBet.hoa;
        }

        //check platform
        paramsBet.betfrom = 3;
        onBet('/topic/rh/bet', paramsBet);
    };

    const resetBet = () => {
        setcurrentMyBet({ xiu: 0, tai: 0, hoa: 0 });
        paramsBet.betamount = 0;
        paramsBet.dragon = 0;
        paramsBet.draw = 0;
        paramsBet.tiger = 0;
        paramsBet.typed = 0;
        reloadBalance();
        setTotalCurrentBet(0);

        //clear chip dom
        if (ref.current) {
            const listCurrentChip = Array.from(ref.current.querySelectorAll('.chipEmbed'));
            listCurrentChip.forEach((element: any) => {
                element.remove();
            });
        }
    };

    const rebet = () => {
        let totalBet = 0;
        chipStoreBet.current.forEach((item) => {
            const keyTypeBet = item.dataset.typebet;
            const chipValueText = (item.querySelector('ion-text') as HTMLElement)?.innerText;

            let chipValue = 0;

            if (chipValueText) {
                if (chipValueText.includes('K')) {
                    chipValue = Number(chipValueText.replace('K', '')) * 1000;
                } else if (chipValueText.includes('M')) {
                    chipValue = Number(chipValueText.replace('M', '')) * 1000000;
                }
            }

            if (keyTypeBet === 'RONG') {
                setMoneyCountTai((value) => (value += chipValue));
                setcurrentMyBet({
                    tai: chipValue,
                    xiu: 0,
                    hoa: 0,
                });
                totalBet += chipValue;
            } else if (keyTypeBet === 'HO') {
                setMoneyCountXiu((value) => (value += chipValue));
                setcurrentMyBet({
                    tai: 0,
                    xiu: chipValue,
                    hoa: 0,
                });
                totalBet += chipValue;
            } else if (keyTypeBet === 'HOA') {
                setMoneyCountHoa((value) => (value += chipValue));
                setcurrentMyBet({
                    tai: 0,
                    xiu: 0,
                    hoa: chipValue,
                });
                totalBet += chipValue;
            }
            setTotalCurrentBet(totalBet);

            chipStoreBet.current.forEach((item) => {
                if (ref.current) {
                    const elBtnTypeBet: HTMLButtonElement = ref.current.querySelector(`[data-infinity="${item.dataset.typebet}"]`);
                    elBtnTypeBet.appendChild(item);
                }
            });
        });
    };

    const generateDotTK = (result: string[]) => {
        const resultNum = result.map((item) => Number(item.split('-')[0]));
        let label = 'R',
            cls = 'tai';
        if (resultNum[0] < resultNum[1]) {
            label = 'H';
            cls = 'xiu';
        }
        return <div className={`tk-item ${cls}`}>{label}</div>;
    };

    return (
        <div className="board-rh-container">

            <div className={`moneyWin ${moneyWin.current !== 0 ? "showMoney" : ""}`} >
                <span>+{moneyWin.current.toLocaleString()}</span>
            </div>

            <div className="table-bet">
                <img className="table-img" src={require(`assets/images/rongho/table.png`)} alt="" />
                <div className="table-inner">
                    <div className="bet-content">
                        <div className="box-card">
                            <div className="box box-left">
                                <img src={require(`assets/images/rongho/box-card-left.png`)} alt="" />
                            </div>

                            <div className="box box-right">
                                <img src={require(`assets/images/rongho/box-card-right.png`)} alt="" />
                            </div>
                        </div>
                        <div className="card-bet">
                            <div className="card-item tai">
                                {!result ? (
                                    <img className={`card-icon ${showCard ? 'show' : ''}`} src={require(`assets/images/rongho/card-left.png`)} alt="" />
                                ) : (
                                    <img className={`card-result ${activePlaceWin === 'RONG' ? 'place-win' : ''}`} src={require(`assets/images/rongho/card/${result[0]}-left.png`)} alt="" />
                                )}
                            </div>
                            <div className="card-bet-center">
                                <p className="issue-text">#{issue}</p>
                                <div className="timer-wrap">
                                    <img className="" src={require(`assets/images/rongho/dia.png`)} alt="" />
                                    <div className={`timer-count ${hideTimer ? 'hide' : ''}`}>
                                        <div ref={timerRef} className={`time-count ${showHotTimer ? 'hot-timer' : ''}`}>
                                            {timerCount}
                                        </div>
                                    </div>
                                </div>
                                {timerFinish && <p className="timer-finish">{timerFinish}</p>}
                            </div>

                            <div className="card-item xiu">
                                {!result ? (
                                    <img
                                        className={`card-icon ${showCard ? 'show' : ''}`}
                                        src={require(`assets/images/rongho/card-right.png`)}
                                    alt=""/>
                                ) : (
                                    <img className={`card-result ${activePlaceWin === 'HO' ? 'place-win' : ''}`} src={require(`assets/images/rongho/card/${result[1]}-right.png`)} alt="" />
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="bar-tk">
                        <div className="bar-tk-inner">
                            <img className="bar-bg" src={require(`assets/images/rongho/bar-tk.png`)} alt="" />
                            <div className="bar-tk-content">
                                {tkBoardList.map((item, index) => (
                                    <React.Fragment key={`${item.id}-${index}`}>{generateDotTK(item.result)}</React.Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <PlaceBetRongHo
                stateBtnBet={stateBtnBet}
                onSelectPlace={selectBet}
                moneyCountTai={moneyCountTai}
                moneyCountXiu={moneyCountXiu}
                moneyCountHoa={moneyCountHoa}
                countConfirmBet={countConfirmBet}
                result={result}
                countUser={countUser}
            />

            <div className="chips-minigame">
                <ChipsRongho ref={chipsListRef} valueActive={chipValue} onSelect={selectChip} />
            </div>
            <div className="footer-action">
                <div className="footer-gird">
                    <div className="footer-row">
                        <div className="footer-col">
                            <button className="btn-reset btn-action" onClick={resetBet}>
                                <img className="action-icon" src={require(`assets/images/rongho/btn-clear.png`)} alt="" />
                            </button>
                        </div>
                        <div className="footer-col footer-bet">
                            <button className="btn-reset btn-bet" onClick={confirmBet}>
                                <p>
                                    CƯỢC: <span>{new Intl.NumberFormat().format(totalCurrentBet)}</span>
                                </p>
                            </button>
                        </div>
                        <div className="footer-col">
                            <button className="btn-reset btn-action" onClick={rebet}>
                                <img className="action-icon" src={require(`assets/images/rongho/btn-rebet.png`)} alt="" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default forwardRef(BoardRongHo);
